import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import shortid from 'shortid'
import onClickOutside from 'react-onclickoutside'
import PlusIcon from '@tecuity/sos-icons/react/plus'
import './FabButton.scss'

class FabButton extends Component {
  constructor() {
    super()
    this.state = { open: false }
  }
  onClick = e => {
    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }
  handleClickOutside = e => {
    if (this.state.open) {
      this.setState({ open: false })
    }
  }
  render() {
    const {
      className = '',
      ariaLabel,
      tooltip,
      tooltipPlacement = 'left',
      mainButton,
      children
    } = this.props
    const { open } = this.state
    const id = shortid.generate()
    const subButtons = React.Children.toArray(children)
    return (
      <div
        className="fab-button"
        onClick={() => {
          this.setState({ open: !open })
        }}
      >
        <button
          className={'main ' + className + (open ? ' open ' : ' ')}
          onClick={this.onClick}
          data-tip={tooltip}
          data-for={id}
          aria-label={ariaLabel || tooltip}
        >
          {mainButton ? mainButton : <PlusIcon />}
          <ReactTooltip effect="solid" place={tooltipPlacement} id={id} />
        </button>
        {subButtons.map((button, i) => (
          <div className="sub-wrapper" key={i}>
            {React.cloneElement(button, {
              tabIndex: open ? 0 : -1,
              style: {
                ...button.props.style,
                transform: `translateY(-${open ? (i + 1) * 50 + 12 : 10}px)`,
                transitionDelay: open ? (subButtons.length - i - 1) * 100 + 'ms' : '',
                opacity: open ? 1 : 0
              }
            })}
          </div>
        ))}
      </div>
    )
  }
}
export default onClickOutside(FabButton)

export class FabSubButton extends Component {
  onClick = e => {
    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }
  render() {
    const {
      className = '',
      children,
      style,
      tooltip = '',
      tooltipPlacement = 'left',
      tabIndex
    } = this.props
    const id = shortid.generate()
    return (
      <button
        className={'sub ' + className}
        style={style}
        data-for={id}
        data-tip={tooltip}
        onClick={this.onClick}
        aria-label={tooltip}
        tabIndex={tabIndex}
      >
        {children}
        {tooltip !== '' ? <ReactTooltip effect="solid" place={tooltipPlacement} id={id} /> : null}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Shell/FabButton.js